import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createVNode as _createVNode, mergeProps as _mergeProps, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "gfu-layout__main gfu-layout__main--narrow js-main-content" }
const _hoisted_2 = { class: "gfu-subheading gfu-subheading--main" }
const _hoisted_3 = {
  key: 3,
  class: "gfu-heading gfu-heading--top-divider _mt-4"
}
const _hoisted_4 = {
  key: 6,
  class: "gfu-hd gfu-hd--h3 _mt-5"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_steps_indicator = _resolveComponent("steps-indicator")
  const _component_payment_checkout_header = _resolveComponent("payment-checkout-header")
  const _component_cart_table = _resolveComponent("cart-table")
  const _component_cart_table_notificator = _resolveComponent("cart-table-notificator")
  const _component_base_notificator = _resolveComponent("base-notificator")
  const _component_checkout_return_actions = _resolveComponent("checkout-return-actions")
  const _component_redeem_gift_cards = _resolveComponent("redeem-gift-cards")
  const _component_order_summary_list = _resolveComponent("order-summary-list")
  const _component_dynamic_currency_conversion_wrapper = _resolveComponent("dynamic-currency-conversion-wrapper")
  const _component_payment_types = _resolveComponent("payment-types")
  const _component_adyen_create_order_payment_section = _resolveComponent("adyen-create-order-payment-section")
  const _component_stripe_payment_form = _resolveComponent("stripe-payment-form")
  const _component_checkout_footer = _resolveComponent("checkout-footer")
  const _component_progress_overlay = _resolveComponent("progress-overlay")
  const _component_box = _resolveComponent("box")
  const _component_project_context_modal = _resolveComponent("project-context-modal")
  const _component_utilize_bonus_amount_modal = _resolveComponent("utilize-bonus-amount-modal")

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    ($options.hasMoreThanOneStep)
      ? (_openBlock(), _createBlock(_component_steps_indicator, {
          key: 0,
          steps: $props.steps,
          "is-in-admin-mode": false
        }, null, 8 /* PROPS */, ["steps"]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("h1", {
      class: _normalizeClass(['gfu-heading gfu-heading--main', {'_mt-6': !$options.hasMoreThanOneStep}]),
      "data-qa": "page-title"
    }, _toDisplayString($options.headerText), 3 /* TEXT, CLASS */),
    _createElementVNode("div", _hoisted_2, _toDisplayString($options.subheaderText), 1 /* TEXT */),
    _createVNode(_component_box, {
      class: "_mt-3 _mb-6",
      "data-qa": "cart-box"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_payment_checkout_header, _normalizeProps(_guardReactiveProps($options.paymentCheckoutHeaderPropsModel)), null, 16 /* FULL_PROPS */),
        _createVNode(_component_cart_table, {
          "order-id": this.currentOrderId
        }, null, 8 /* PROPS */, ["order-id"]),
        _createVNode(_component_cart_table_notificator, {
          "checkout-return-action-url": $props.checkoutReturnActionsModel.actionUrl
        }, null, 8 /* PROPS */, ["checkout-return-action-url"]),
        ($options.shouldDisplayNotificator)
          ? (_openBlock(), _createBlock(_component_base_notificator, _mergeProps({ key: 0 }, $props.notificatorModel, { class: "_my-2" }), null, 16 /* FULL_PROPS */))
          : _createCommentVNode("v-if", true),
        (_ctx.isAuthenticated)
          ? (_openBlock(), _createBlock(_component_checkout_return_actions, _normalizeProps(_mergeProps({ key: 1 }, $props.checkoutReturnActionsModel)), null, 16 /* FULL_PROPS */))
          : _createCommentVNode("v-if", true),
        ($options.isStoreDataInitialized)
          ? (_openBlock(), _createBlock(_component_redeem_gift_cards, {
              key: 2,
              "project-id": _ctx.projectID,
              "currency-symbol": $options.currencySymbol,
              "is-checkout-processing": $setup.isProcessingView,
              onGiftCardsChanged: $options.onGiftCardsChanged
            }, null, 8 /* PROPS */, ["project-id", "currency-symbol", "is-checkout-processing", "onGiftCardsChanged"]))
          : _createCommentVNode("v-if", true),
        _createVNode(_component_order_summary_list, { "order-id": _ctx.currentOrderId }, null, 8 /* PROPS */, ["order-id"]),
        ($options.isPaymentRequired)
          ? (_openBlock(), _createElementBlock("h2", _hoisted_3, _toDisplayString(_ctx.Resources.Checkout.CheckoutPaymentOptionsSectionTitle), 1 /* TEXT */))
          : _createCommentVNode("v-if", true),
        (_ctx.isInitialized)
          ? (_openBlock(), _createBlock(_component_dynamic_currency_conversion_wrapper, {
              key: 4,
              "project-id": _ctx.projectID,
              "order-id": _ctx.currentOrderId,
              "order-code": $props.effectiveOrderCode,
              reason: _ctx.paymentMethodsByOrderPaymentType,
              "can-be-paid-in-installments": _ctx.canBePaidInInstallments,
              "payment-currency-strategy": $props.paymentCurrencyStrategy,
              "order-code-for-installment-calculation": $options.orderCodeForInstallmentCalculation
            }, null, 8 /* PROPS */, ["project-id", "order-id", "order-code", "reason", "can-be-paid-in-installments", "payment-currency-strategy", "order-code-for-installment-calculation"]))
          : _createCommentVNode("v-if", true),
        ($options.arePaymentTypesVisible)
          ? (_openBlock(), _createBlock(_component_payment_types, {
              key: 5,
              "current-payment-type": _ctx.paymentType,
              "checkout-mode": $options.checkoutMode,
              "effective-payable-amount": $options.effectivePayableAmount,
              "order-code": $options.orderCodeForInstallmentCalculation,
              onPaymentTypeChanged: $options.onPaymentTypeChanged,
              "data-qa": "installments-wrapper"
            }, null, 8 /* PROPS */, ["current-payment-type", "checkout-mode", "effective-payable-amount", "order-code", "onPaymentTypeChanged"]))
          : _createCommentVNode("v-if", true),
        ($options.isPaymentRequired)
          ? (_openBlock(), _createElementBlock("h3", _hoisted_4, _toDisplayString(_ctx.Resources.Checkout.CheckoutPaymentMethodSectionTitle), 1 /* TEXT */))
          : _createCommentVNode("v-if", true),
        ($options.isStoreDataInitialized && $options.isAdyenPaymentProvider)
          ? (_openBlock(), _createBlock(_component_adyen_create_order_payment_section, _mergeProps({ key: 7 }, $options.paymentOptionsModel, { "data-qa": "payment-section" }), null, 16 /* FULL_PROPS */))
          : _createCommentVNode("v-if", true),
        ($options.isStoreDataInitialized && !$options.isAdyenPaymentProvider)
          ? (_openBlock(), _createBlock(_component_stripe_payment_form, _mergeProps({ key: 8 }, $options.paymentOptionsModel, { "data-qa": "stripe-payment-form" }), null, 16 /* FULL_PROPS */))
          : _createCommentVNode("v-if", true),
        _createVNode(_component_checkout_footer, { "show-digital-content-info": $props.hasDigitalItems }, null, 8 /* PROPS */, ["show-digital-content-info"]),
        _createVNode(_component_progress_overlay, { visible: $setup.isProcessingView }, null, 8 /* PROPS */, ["visible"])
      ]),
      _: 1 /* STABLE */
    }),
    _createVNode(_component_project_context_modal),
    ($options.isUtilizeBonusAmountModalAvailable)
      ? (_openBlock(), _createBlock(_component_utilize_bonus_amount_modal, {
          key: 1,
          "is-visible": _ctx.isUtilizeBonusAmountModalVisible,
          "project-id": _ctx.projectID,
          "order-code": $options.orderCode,
          "bonus-amount": $options.bonusAmount,
          "currency-symbol": $options.currencySymbol,
          onBonusAmountUtilized: $options.onBonusAmountUtilized,
          onClose: $options.closeUtilizeBonusAmountModal
        }, null, 8 /* PROPS */, ["is-visible", "project-id", "order-code", "bonus-amount", "currency-symbol", "onBonusAmountUtilized", "onClose"]))
      : _createCommentVNode("v-if", true)
  ]))
}